const PageContainer = ({ render, parentState }) => render(parentState);

export default PageContainer;
